import { NormalTextEditorInputFiled, NormalTextInputField } from "@/components";
import React from "react";

const StartYourBusinessFacilityOptionsSection = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
  handleTextEditorInputChange,
}) => {
  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="start-your-business-section-4-facility-options-heading"
        fieldName="start-your-business-section-4-facility-options-heading"
        placeholderText="Heading"
        inputValue={
          stateDetails?.[
            "start-your-business-section-4-facility-options-heading"
          ] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />

      {/* Sub Heading */}
      {/* <NormalTextInputField
        isFetching={isFetching}
        isTextArea={true}
        labelText="Sub Heading"
        fieldId="start-your-business-section-4-facility-options-sub-heading"
        fieldName="start-your-business-section-4-facility-options-sub-heading"
        placeholderText="Sub Heading"
        inputValue={
          stateDetails?.[
            "start-your-business-section-4-facility-options-sub-heading"
          ] || ""
        }
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      /> */}
      <NormalTextEditorInputFiled
        isFetching={isFetching}
        labelText="Section Content"
        fieldId="start-your-business-section-4-facility-options-content"
        fieldName="start-your-business-section-4-facility-options-content"
        placeholderText="Sub Heading"
        inputValue={
          stateDetails?.[
            "start-your-business-section-4-facility-options-content"
          ] || ""
        }
        onChangeTextEditorFiled={handleTextEditorInputChange}
        translateField={true}
        extraContainerClasses="mb-5"
      />
    </>
  );
};

export default StartYourBusinessFacilityOptionsSection;
